import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

@Injectable()
export class CommonService {
  constructor(private http: HttpClient) {}

  downloadFile(url: string): void {
    this.http
      .get<Blob>(url, {
        responseType: 'blob' as 'json',
        observe: 'response',
      })
      .subscribe((res: HttpResponse<Blob>) => {
        let fileName: any = res.headers.get('FileName');

        fileName = decodeURIComponent(fileName);
        let data: any = res.body;
        saveAs(data, fileName);
      });
  }

  downloadTemplate(templateName: string): void {
    this.downloadFile('/api/admin/assets/download?template=' + templateName);
  }
}
